var _g, _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPendingComparison(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_88_13700)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 35.5,
    r: 32.5,
    fill: "#962DFF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5036 17.749L22.665 19.585L25.4007 22.3193L27.2366 20.4834L24.5023 17.749H24.5036ZM48.4977 17.749L45.7621 20.4834L47.5993 22.3193L50.3337 19.5863L48.4977 17.749ZM36.5 18.5638C36.0691 18.5691 35.6329 18.5939 35.1942 18.6474C35.1811 18.6474 35.1681 18.6448 35.155 18.6474C29.8587 19.2546 25.6435 23.5337 24.911 28.8066C24.326 33.0504 26.0758 36.8986 28.9916 39.377C30.1844 40.395 30.9911 41.7918 31.2768 43.3336V51.1684H34.254C34.7084 51.948 35.5376 52.4743 36.5 52.4743C37.4624 52.4743 38.2916 51.948 38.746 51.1684H41.7232V45.9452L41.846 44.3939C41.846 42.4796 42.841 40.5497 44.4576 39.0493C46.62 36.8843 48.2522 33.8091 48.2522 30.2769C48.2522 23.8262 42.9428 18.5038 36.5 18.5638ZM18.2188 30.2769V32.8885H22.1362V30.2769H18.2188ZM50.8638 30.2769V32.8885H54.7812V30.2769H50.8638ZM25.4007 40.8461L22.6663 43.5791L24.5036 45.4164L27.2353 42.682L25.4007 40.8461ZM47.5993 40.8461L45.7634 42.682L48.4964 45.4164L50.3337 43.5791L47.5993 40.8461ZM33.8884 47.2523H39.1116V48.5581H33.8884V47.2523Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7486 21.0368C31.9795 21.2671 28.0163 24.7101 27.0596 29.4886C26.9315 30.1312 26.8901 30.7947 26.8591 31.4519C26.8199 32.2682 27.3613 32.8731 28.0948 32.8961C28.8263 32.9191 29.3925 32.3498 29.4193 31.5335C29.504 28.8732 30.5682 26.7362 32.6614 25.156C33.864 24.2476 35.234 23.7787 36.7238 23.6866C36.9098 23.6741 37.0957 23.6825 37.2796 23.6594C37.9595 23.5736 38.4492 22.9876 38.4244 22.2989C38.3975 21.6124 37.8623 21.0682 37.1763 21.0389C37.0338 21.0326 36.8912 21.0389 36.7486 21.0389V21.0368Z",
    fill: "#962DFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 33.8884,
    y: 44.6406,
    width: 5.22321,
    height: 1.3058,
    fill: "#962DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_88_13700",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_88_13700"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_88_13700",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingComparison);
export default __webpack_public_path__ + "static/media/pendingComparison.cf9a08883363bd9fb350f04b745fbcd5.svg";
export { ForwardRef as ReactComponent };